import { departments, directionAPI, directionGroupApi, usersAPI } from '@/api'
import { ColleagueFormData, ErrorResponse, IDepartmentIndex } from './types'

type DepartmentTreeItem = {
  id: number
  name: string
  children?: DepartmentTreeItem[]
}

const flattenDepartments = (
  items: DepartmentTreeItem[] = [],
): IDepartmentIndex[] => {
  return items.flatMap((item) => [
    {
      id: item.id,
      label: item.name,
    },
    ...flattenDepartments(item.children ?? []),
  ])
}

export const fetchAllCourses = async (): Promise<ICourse[]> => {
  try {
    const res = await directionAPI.getAll()
    return res?.data?.data ?? []
  } catch (error) {
    console.error('Ошибка загрузки курсов:', error)
    return []
  }
}

export const fetchAllGroups = async ({
  expand = [],
}: {
  expand?: string[]
} = {}): Promise<(IGroup & { teacher: ISeminarian; supervisor?: IUser })[]> => {
  try {
    const res = await directionGroupApi.get({
      expand: ['teacher', 'supervisor',...expand],
    })
    return res?.data ?? []
  } catch (error) {
    console.error('Ошибка загрузки групп:', error)
    return []
  }
}

export const fetchDepartmentIndexes = async (): Promise<IDepartmentIndex[]> => {
  try {
    const res = await departments.getAll('all')
    return flattenDepartments(res?.data ?? [])
  } catch (error) {
    console.error('Ошибка загрузки отделов:', error)
    return []
  }
}

export const createColleague = async (
  colleague: ColleagueFormData,
): Promise<ErrorResponse<IUser>> => {
  try {
    const res = await usersAPI.create({ data: colleague })
    return (res as any)?.response?.data ?? res.data
  } catch (error) {
    console.error('Ошибка при создании сотруднитка:', error)
    return {
      status: 'error',
      error: 'Ошибка при создании сотруднитка',
      trace: [],
    }
  }
}
